var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/FundingYourProductConstants.js').ActionTypes;

module.exports = {
    setActiveFundType: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_ACTIVE_FUND_TYPE,
            data: data
        });
    },
    updateInvestmentVisibility: function (hideInvestments, index, isInternalAccounts) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_INVESTMENTS_VISIBILITY,
            hideInvestments: hideInvestments,
            index: index,
            isInternalAccounts: isInternalAccounts
        });
    },
    startEditMode: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.START_EDIT_FUNDING_TYPE,
            index: index
        });
    },
    endEditMode: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.END_EDIT_FUNDING_TYPE,
            index: index
        });
    },
    cancelEditMode: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CANCEL_EDIT_FUNDING_TYPE,
            index: index
        });
    },
    toggleFundingTypeVisibility: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_FUNDING_TYPE_VISIBILITY
        });
    },
    submitInternalRollover: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SUBMIT_INTERNAL_ROLLOVER
        });
    },
    updateNewRollover: function (fieldId, value, rollOverType, nonRollover) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_NEW_ROLLOVER,
            fieldId: fieldId,
            value: value,
            rollOverType: rollOverType,
            nonRollover: nonRollover
        });
    },
    submitNewExternalRollover: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SUBMIT_NEW_EXTERNAL_ROLLOVER
        });
    },
    deleteFromSummary: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DELETE_FUNDING_TYPE,
            index: index
        });
    },
    validateSectionSetup: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_FUNDING_SECTION_SETUP
        });
    },
    updateExistingRollover: function (fieldId, value, rollOverType, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_EXISTING_ROLLOVER,
            fieldId: fieldId,
            value: value,
            rollOverType: rollOverType,
            index: index
        });
    },
    clearNewFundingType: function (fromInternal) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_NEW_FUNDING_TYPE,
            fromInternal: fromInternal
        });
    },
    submitOtherFundType: function (rollOverType) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SUBMIT_OTHER_FUND_TYPE,
            rollOverType: rollOverType
        });
    },
    endEditNonRollover: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.END_EDIT_NON_ROLLOVER,
            index: index
        });
    },
    setInternalRolloverInfo: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_INTERNAL_ROLLOVER_INFO,
            data: data
        });
    },
    updateInternalAccountDetails: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_INTERNAL_ACCOUNT_DETAILS,
            data: data
        });
    },
    loadSuperFundList: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.LOAD_SUPER_FUND_LIST,
            data: data
        });
    },
    updateExternalPredictiveDetails: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_EXTERNAL_PREDICTIVE_DETAILS,
            data: data
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/FundingYourProductActions.js